@import (reference) '../../../../constants/spacing.module.less';

@header-height: 72px;
@side-panel-width: 264px;

.header {
  background: var(--light--header--background-color--1);
  position: fixed;
  height: @header-height;
  width: @side-panel-width;
  padding: 24px 16px;
  border-right: solid 1px var(--default--border-color--10);
}

.left {
  align-items: center;
}

.marketplace-icon {
  height: 20px;
  margin-right: @space-8;
}

.title {
  color: var(--dark--text-color--1);
}

.close-button {
  > svg {
    height: 12px;
    width: 12px;
    fill: var(--default--icon--fill-color--11);
  }
}

.information-banner {
  font-size: 14px;
  line-height: 24px;
  color: var(--default--text-color--17);
}

.labeled-field {
  .label {
    color: var(--default--text-color--17);
    font-size: 14px;
    line-height: 24px;
    font-weight: 500;
    margin-bottom: @space-4;
  }
}

.field-content {
  color: var(--default--text-color--17);
  font-size: 14px;
  line-height: 24px;
  font-weight: 400;
}

.split-flex-row {
  flex: 1;
  gap: @space-8;
}

.external-link-icon {
  display: inline-block;
  height: 10px;
  margin-left: @space-8;
}

.order-summary-sections {
  margin-top: @header-height;
}
